import { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";

const StockNameContext = createContext(null);
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const StockNameProvider = ({ children }) => {
  const [stockData, setStockData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStock = useCallback(async (stockName) => {
    if (!stockName) return;

    setLoading(true);
    setError(null);
    console.log("Stock Name recieved", stockName);
    try {
      const response = await axios.get(`${BASE_URL}/api/stock`, {
        params: { stock_name: stockName },
      });

      console.log("Stock dataa in context", response.data);
      setStockData(response.data);
    } catch (err) {
      setError("Failed to fetch stock data");
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <StockNameContext.Provider
      value={{
        stockData,
        loading,
        error,
        fetchStock,
      }}
    >
      {children}
    </StockNameContext.Provider>
  );
};

export const useStockName = () => useContext(StockNameContext);
